import React, { ButtonHTMLAttributes } from "react";
import styles from "./BtnWithProcessing.module.css";
import clsx from "clsx";

interface ProcessingButtonBaseProps
  extends ButtonHTMLAttributes<HTMLButtonElement> {
  labelProcessing: string;
  isProcessing: boolean;
  variant?: "primary" | "secondary";
  fullWidth?: boolean;
}

const ProcessingButtonBase: React.FC<ProcessingButtonBaseProps> = ({
  labelProcessing,
  isProcessing,
  fullWidth = false,
  variant = "primary",
  className,
  children,
  ...buttonProps
}) => {
  if (isProcessing) {
    return (
      <div
        className={clsx(styles.loading, className)}
        data-full-width={fullWidth}
        style={buttonProps.style}
      >
        <span>{labelProcessing}</span>
        <div className={styles.loader}>
          <div></div>
          <div></div>
          <div></div>
          <div></div>
        </div>
      </div>
    );
  } else {
    return (
      <button
        className={clsx(styles.btn, className)}
        data-full-width={fullWidth}
        data-secondary={variant === "secondary"}
        {...buttonProps}
      >
        {children}
      </button>
    );
  }
};

export default ProcessingButtonBase;
